<template>
  <div class="cpManagement common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索池名称：</div>
          <div class="content">
            <el-input v-model="form.poolName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addCluePool">新建</el-button>
    </div>
    <commonTable ref="cluePoolManagementTable" />
    <addCluePoolDialog
      :row-data="rowData"
      :add-pool-visible="addPoolVisible"
      @addCluePool="addCluePoolHandle"
      @dialogCloseHandle="addPoolDialogClose"
      @editCluePool="editCluePoolHandle"
    />
    <showClueManage
      :dateile-data="showDateilData"
      :show-clue-vis="showClueVis"
      @dialogCloseHandle="showClueClose"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addCluePoolDialog from './component/cluePoolManagement/addCluePoolDialog';
import showClueManage from './component/cluePoolManagement/showClueManage';
import { cluePoolManagementApi } from './service';

export default {
  data () {
    return {
      form: {
        type: 1
      },
      expensesTypeList: [],
      rules: {
        poolName: [
          { required: true, message: '请输入线索池名称', trigger: 'blur' },
          { max: 20, message: '最多 20 个字符', trigger: 'change' }
        ]
      },
      addPoolVisible: false,
      rowData: {},
      showClueVis: false,
      showDateilData: {}
    };
  },
  components: {
    commonTable,
    addCluePoolDialog,
    showClueManage
  },
  methods: {
    addPoolDialogClose () {
      this.rowData = {};
      this.addPoolVisible = false;
    },
    editCluePoolHandle (params) {
      this.$store.commit('setSubPageLoading', true);
      cluePoolManagementApi.cluePoolUpdate(params).then(res => {
        if (res.status === '200') {
          this.addPoolDialogClose();
          this.searchBtn();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addCluePoolHandle (params) {
      this.$store.commit('setSubPageLoading', true);
      cluePoolManagementApi.addCluePool(params).then(res => {
        if (res.status === '200') {
          this.addPoolDialogClose();
          this.searchBtn();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    reset () {
      this.form = {
        type: 1
      };
      this.searchBtn('deptCodeForm');
    },
    searchBtn () {
      this.$refs.cluePoolManagementTable.pageData.pageNum = 1;
      this.$refs.cluePoolManagementTable.getTableData({ url: '/lead/pool-management/lead-list', params: this.form });
    },
    showDetail (poolId) {
      cluePoolManagementApi.DetailAll(poolId).then(res => {
        this.showDateilData = res.data;
      });
      this.showClueVis = true;
    },
    editHandlen (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addPoolVisible = true;
    },
    deleteHand (row) {
      this.$confirm('确定删除该线索池?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('susscs');
      }).catch(() => {
        console.log('waring');
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('线索池ID')
          ._width('10%')
          ._data('poolId')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <el-button type="text" onClick={() => { this.showDetail(row.poolId); }}>{ row.poolId }</el-button>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('线索池名称')
          ._width('8%')
          ._data('poolName')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建时间')
          ._width('10%')
          ._data('createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('线索数量')
          ._width('8%')
          ._data('num')
      );
      tableRow.push(
        new TableColumns()
          ._title('线索池管理员')
          ._width('8%')
          ._data('admins')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let adminsList = row.admins ? row.admins.map(item => {
                return item.adminName;
              }) : [];
              return (
                <span>{ adminsList.join(',') }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('线索池所属部门')
          ._width('8%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('10%')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.editHandlen(row); }}>编辑</el-button>
                  { /** <el-button type="text" onClick={() => { this.deleteHand(row); }}>删除</el-button> **/ }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.cluePoolManagementTable.setColumn(column);
      this.$refs.cluePoolManagementTable.loadTable({ url: '/lead/pool-management/lead-list', listKey: 'poolVOList', params: this.form });
    },
    addCluePool () {
      this.addPoolVisible = true;
    },
    showClueClose () {
      this.showClueVis = false;
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>

<style scoped>

</style>
